import { FundPortfolio, Portfolio } from 'model/fund';

export interface BlockedIssuersPayload {
    issuerIds?: string[];
}

type IsIssuerBlockedFn = (issuerId: string) => boolean;

export const parseBlockedIssuerIds = (enabled: boolean, payloadValue?: string | null): Set<string> => {
    if (!enabled || !payloadValue) {
        return new Set();
    }

    try {
        const parsed = JSON.parse(payloadValue) as BlockedIssuersPayload;

        if (!parsed?.issuerIds || !Array.isArray(parsed.issuerIds)) {
            return new Set();
        }

        return new Set(parsed.issuerIds.filter(issuerId => typeof issuerId === 'string' && issuerId.length > 0));
    } catch {
        return new Set();
    }
};

export const isIssuerInBlockedList = (blockedIssuerIds: Set<string>, issuerId: string): boolean => {
    return blockedIssuerIds.has(issuerId);
};

export const filterFundsByBlockedIssuers = <T extends { id: string }>(funds: T[], isBlocked: IsIssuerBlockedFn): T[] => {
    return funds.filter(fund => !isBlocked(fund.id));
};

export const buildVisiblePortfolio = (portfolio: Portfolio | undefined, isBlocked: IsIssuerBlockedFn): Portfolio | undefined => {
    if (!portfolio) {
        return undefined;
    }

    const visibleFunds = filterFundsByBlockedIssuers(portfolio.funds, isBlocked);
    const totalValue = visibleFunds.reduce((sum, fund) => sum + fund.totalValue, 0);

    const fundsWithRenormalizedShare: FundPortfolio[] = visibleFunds.map(fund => ({
        ...fund,
        sharePercentage: totalValue > 0 ? (fund.totalValue / totalValue) * 100 : 0
    }));

    return {
        ...portfolio,
        totalValue,
        totalFunds: fundsWithRenormalizedShare.length,
        funds: fundsWithRenormalizedShare
    };
};

export const formatHiddenBalance = (isBlocked: boolean, amount: number, formatFn: (value: number) => string): string => {
    if (isBlocked) {
        return '-';
    }

    return formatFn(amount);
};
